module.exports = __webpack_public_path__ + "static/media/logo-jimini-black.7b362784.png";